module.exports = __webpack_public_path__ + "static/media/Bradford-Declaration-Of-Easements-Covenants-Restriction.231a6047.pdf";